export default __webpack_public_path__ + "static/media/element_6.ba2719cd.webp";